export enum ReservationStatus {
  active = 'active',
  canceled = 'canceled',
  delivered = 'delivered',
  notDelivered = 'not-delivered'
}

export enum InvoicePaymentStatus {
  notPaid = 'not-paid',
  fullyPaid = 'fully-paid',
  partiallyPaid = 'partially-paid',
  notDetermined = 'not-determined'
}